

// --------------------------------------- Designs List
export const DesignList = [
    {
        img: "Band page - d1.png",
        title: "Band page",
        description: "Design of a full page for a music group. Displayed here the main page.",
        img_credit: "Stock image from the internet",
        figma_url: "https://www.figma.com/file/XDGpFLeGCgcfFSLwzZpN1e/Music-Band-Website---public?type=design&node-id=0%3A1&mode=design&t=gA6kUQPKZ6KnnEWa-1"
    },
    {
        img: "Growth platform - d1.png",
        title: "Growth platform",
        description: "Design done in the context of a Hackathon of a webapplication to enable employees to help each other grow as well in their soft skills than in their hard skills. Displayed here the main view.",
        img_credit: "Stock image from the internet",
        figma_url: "https://www.figma.com/file/rqKAI3SgGrHHjDWZMcEntZ/Knowledge-Growth-Platform---public?type=design&node-id=0%3A1&mode=design&t=gA6kUQPKZ6KnnEWa-1"
    },
    {
        img: "Request builder - d1.png",
        title: "Request builder",
        description: "Design of a simple webapplication to enable non-technical users to build an api request based on the possible parameters. Displayed here the second page.",
        figma_url: "https://www.figma.com/file/tkRwnwANs7pfvCC0inm6Be/Request-Builder---public?type=design&node-id=2%3A8&mode=design&t=gA6kUQPKZ6KnnEWa-1"
    }
];